/** @format */

import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import PlusNotifyInterface from '../../../interfaces/platform/PlusNotifyInterface';
import {DateHelperTs} from "../../../helpers/DateHelperTs";
import {PlusNotifyHelper} from "../../../helpers/PlusNotifyHelper";
import i18next from "i18next";

const NotifyView = (item: PlusNotifyInterface): React.ReactElement<any, string | React.JSXElementConstructor<any>> => {
    const size = 6;
    const variant = 'subtitle2';

    const isOpl = item.notificationType === '1001';

    const displayFupStatus = (item: PlusNotifyInterface):string => {
        let msg = 'simcard:list.undefined';
        if(item.notify.JSON_RESPONSE && typeof item.notify.JSON_RESPONSE === 'object' && item.notify.JSON_RESPONSE.FUP_STATUS_VALUE) {
            switch (item.notify.JSON_RESPONSE.FUP_STATUS_VALUE) {
                case 1:
                    msg = 'simcard:list.green';
                    break;
                case 2:
                    msg = 'simcard:list.yellow';
                    break;
                case 3:
                    msg = 'simcard:list.red';
                    break;
                default:
                    msg = 'simcard:list.undefined';
            }
        }
        return msg;
    }

    const displayFupMessage = (item: PlusNotifyInterface): string => {
        if(item.notify.JSON_RESPONSE && typeof item.notify.JSON_RESPONSE === 'object' && item.notify.JSON_RESPONSE.FUP_MESSAGE) {
            return item.notify.JSON_RESPONSE.FUP_MESSAGE;
        }
        return '';
    }

    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={size}>
                    <GridContainer>
                        <GridItem xs={size}>
                            <Typography variant={variant}>
                                <I18n trans="prov:list.id" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={size}>{item.id}</GridItem>
                        {!isOpl && (
                            <React.Fragment>
                                {item.typeGroupId !== 1 &&
                                    <>
                                    <GridItem xs={size}>
                                        <Typography variant={variant}>
                                            <I18n trans="prov:list.operation"/>
                                        </Typography>
                                    </GridItem>
                                    <GridItem xs={size}>{item.notify.operation}</GridItem>
                                    </>
                                }
                                <GridItem xs={size}>
                                    <Typography variant={variant}>
                                        <I18n trans="prov:list.event_date" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={size}>{item.typeGroupId !== 1 ? item.notify.eventdate :  item.eventDate ? DateHelperTs.format(item.eventDate) : ''}</GridItem>
                                <GridItem xs={size}>
                                    <Typography variant={variant}>
                                        <I18n trans="prov:list.notification_type" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={size}>{item.typeGroupId !== 1 ? item.notify.notificationtype : <I18n trans={PlusNotifyHelper.notificationGroupType(item.typeGroupId.toString())}/>}</GridItem>
                            </React.Fragment>
                        )}
                        <GridItem xs={size}>
                            <Typography variant={variant}>
                                <I18n trans="prov:list.msisdn" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={size}>{item.msisdn}</GridItem>
                        <GridItem xs={size}>
                            <Typography variant={variant}>
                                <I18n trans="prov:list.imsi" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={size}>{item.imsi}</GridItem>
                        {item.typeGroupId === 1 &&
                            <>
                                <GridItem xs={size}>
                                    <Typography variant={variant}>
                                        <I18n trans="simcard:list.fup_status" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={size}><I18n trans={displayFupStatus(item)}/></GridItem>
                                <GridItem xs={size}>
                                    <Typography variant={variant}>
                                        <I18n trans="simcard:list.fup_message" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={size}>{displayFupMessage(item)}</GridItem>
                            </>
                        }
                    </GridContainer>
                </GridItem>
                {item.typeGroupId !== 1 &&  <GridItem xs={size}>
                    {!isOpl && (
                        <GridContainer>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.notification_direction" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.threholddirection}</GridItem>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.account_balance" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.accountbalance}</GridItem>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.threholdamount" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.threholdamount}</GridItem>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.threholdname" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.threholdname}</GridItem>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.tariff_name" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.tariffname}</GridItem>
                            <GridItem xs={size}>
                                <Typography variant={variant}>
                                    <I18n trans="prov:list.language" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={size}>{item.notify.language}</GridItem>
                        </GridContainer>
                    )}
                </GridItem>}

            </GridContainer>
            {item.typeGroupId !== 1 &&
                <Card style={{paddingLeft: 0}}>
                    <CardHeader>
                        <Typography variant={variant}>
                            <I18n trans="prov:list.xml_from_plk" />
                        </Typography>
                    </CardHeader>
                    {!isOpl && <CardBody xs={12}>{item.notify.XML_RESPONSE}</CardBody>}
                    {isOpl && <CardBody xs={12}>{item.notify.JSON_RESPONSE}</CardBody>}
                </Card>
            }

        </React.Fragment>
    );
};

export default NotifyView;
